import React from "react";

export default function Financials() {
  const turnoverData = [
    { year: "2017-18", amount: 57718575, label: "₹5,77,18,575" },
    { year: "2018-19", amount: 50507118, label: "₹5,05,07,118" },
    { year: "2019-20", amount: 63418018, label: "₹6,34,18,018" },
    { year: "2020-21", amount: 70261615, label: "₹7,02,61,615" },
    { year: "2021-22", amount: 72010129, label: "₹7,20,10,129" },
    { year: "2022-23", amount: 76018579, label: "₹7,60,18,579" },
    { year: "2023-24", amount: 79807119, label: "₹7,98,07,119" },
  ];

  const maxAmount = Math.max(...turnoverData.map((d) => d.amount));
  const cumulativeTotal = "₹46,97,41,153";

  return (
    <section
      id="financials"
      className="py-5 position-relative"
      style={{
        background:
          "linear-gradient(to bottom, #ffffff 0%, #f8fafc 100%)",
      }}
    >
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <div className="d-inline-flex align-items-center gap-2 bg-primary bg-opacity-10 text-primary rounded-pill px-4 py-2 mb-3">
            <i className="bi bi-shield-check"></i>
            <span className="small fw-semibold text-uppercase">
              Audited Accountability
            </span>
          </div>

          <h2 className="display-5 fw-bold text-dark mb-3">
            Organizational Turnover & Financial Scale
          </h2>

          <p
            className="text-muted mx-auto"
            style={{ maxWidth: "720px" }}
          >
            Demonstrating consistent operational growth, transparent
            governance, and sustained financial expansion across
            consecutive fiscal years.
          </p>
        </div>

        <div className="row g-4 align-items-stretch">
          {/* Left Side */}
          <div className="col-lg-5">
            <div className="d-flex flex-column gap-4 h-100">
              {/* Main Financial Card */}
              <div className="financial-main-card position-relative overflow-hidden">
                <div className="financial-bg-icon">
                  <i className="bi bi-safe2"></i>
                </div>

                <div className="position-relative">
                  <span className="badge bg-warning text-dark px-3 py-2 rounded-pill mb-3">
                    Cumulative Financial Scale
                  </span>

                  <p className="text-white-50 small text-uppercase mb-2">
                    Total Audited Gross Turnover
                  </p>

                  <h2 className="display-5 fw-bold text-white mb-3">
                    {cumulativeTotal}
                  </h2>

                  <p className="text-white-50 mb-0 lh-lg">
                    Reflecting strong infrastructure capability,
                    institutional reliability, and effective management
                    of large-scale skill development initiatives and
                    social impact programs.
                  </p>
                </div>
              </div>

              {/* Compliance Section */}
              <div className="card border-0 shadow-sm rounded-4 p-4 h-100">
                <h5 className="fw-bold text-dark mb-4">
                  <i className="bi bi-patch-check-fill text-primary me-2"></i>
                  Regulatory Compliance
                </h5>

                <div className="d-flex flex-column gap-3">
                  <div className="compliance-box compliance-primary">
                    <div className="compliance-icon bg-primary bg-opacity-10 text-primary">
                      <i className="bi bi-bank2"></i>
                    </div>

                    <div>
                      <h6 className="fw-semibold mb-1 text-dark">
                        Ministry of Home Affairs
                      </h6>

                      <small className="text-muted">
                        Officially Registered Organization
                      </small>
                    </div>
                  </div>

                  <div className="compliance-box compliance-success">
                    <div className="compliance-icon bg-success bg-opacity-10 text-success">
                      <i className="bi bi-file-earmark-check"></i>
                    </div>

                    <div>
                      <h6 className="fw-semibold mb-1 text-dark">
                        Income Tax Department
                      </h6>

                      <small className="text-muted">
                        Registered Compliance Framework
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-7">
            <div className="card border-0 shadow-sm rounded-4 p-4 h-100">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 border-bottom pb-3 mb-4">
                <h5 className="fw-bold text-dark mb-0">
                  <i className="bi bi-bar-chart-line-fill text-primary me-2"></i>
                  Year-wise Financial Progress
                </h5>

                <span className="badge bg-light text-secondary border px-3 py-2">
                  Values in INR (₹)
                </span>
              </div>

              <div className="d-flex flex-column gap-4">
                {turnoverData.map((data, idx) => {
                  const percentageWidth = Math.round(
                    (data.amount / maxAmount) * 100
                  );

                  return (
                    <div key={idx} className="financial-row">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold text-dark small">
                          <i className="bi bi-calendar3 text-primary me-2"></i>
                          FY {data.year}
                        </div>

                        <div className="fw-bold text-primary">
                          {data.label}
                        </div>
                      </div>

                      <div
                        className="progress rounded-pill bg-light"
                        style={{ height: "12px" }}
                      >
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          style={{
                            width: `${percentageWidth}%`,
                            background:
                              "linear-gradient(90deg,#2563eb,#1d4ed8)",
                          }}
                        ></div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Summary */}
              <div className="summary-box mt-5">
                <div>
                  <small className="text-primary text-uppercase fw-semibold">
                    Grand Total Summary
                  </small>
                </div>

                <h4 className="fw-bold text-primary mb-0">
                  {cumulativeTotal}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style>{`
        .financial-main-card {
          background: linear-gradient(135deg, #0f172a, #1e293b);
          border-radius: 24px;
          padding: 2rem;
          min-height: 320px;
          color: white;
          box-shadow: 0 1rem 2rem rgba(15, 23, 42, 0.15);
        }

        .financial-bg-icon {
          position: absolute;
          right: -20px;
          bottom: -20px;
          font-size: 10rem;
          opacity: 0.06;
          color: white;
        }

        .compliance-box {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          border-radius: 18px;
          background: #f8fafc;
          transition: all 0.3s ease;
          border-left: 4px solid transparent;
        }

        .compliance-box:hover {
          transform: translateY(-3px);
          background: white;
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.06);
        }

        .compliance-primary {
          border-left-color: #0d6efd;
        }

        .compliance-success {
          border-left-color: #198754;
        }

        .compliance-icon {
          width: 52px;
          height: 52px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.3rem;
          flex-shrink: 0;
        }

        .financial-row {
          transition: all 0.25s ease;
        }

        .financial-row:hover {
          transform: translateX(4px);
        }

        .financial-row:hover .progress-bar {
          filter: brightness(1.05);
        }

        .summary-box {
          background: rgba(13, 110, 253, 0.06);
          border: 1px solid rgba(13, 110, 253, 0.12);
          border-radius: 20px;
          padding: 1.25rem 1.5rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        @media (max-width: 768px) {
          .display-5 {
            font-size: 2.2rem;
          }

          .financial-main-card {
            padding: 1.5rem;
          }
        }
      `}</style>
    </section>
  );
}